import dayjs from "dayjs";

export const describeFrecuency = (frequency = "", intervals = 0) => {
	if(frequency === "" && intervals === 0){
		return "Esperando valores de Frecuencia e Intervalos...";
	}
		
	if(frequency === ""){
		return "Esperando frecuencia";
	}

	if(intervals === 0){
		return "Esperando intervalos";
	}
	
	switch (frequency) {
	case "daily":				
		return `${intervals === 1 ? "diariamente" : `por cada ${intervals} días`}`;

	case "weekly":				
		return `Cada ${intervals === 1 ? "semana" : `${intervals} semanas`}`;

	case "monthly":				
		return `Cada ${intervals === 1 ? "mes" : `${intervals} meses`}`;

	case "yearly":				
		return `Cada ${intervals === 1 ? "año" : `${intervals} años`}`;
	}		
};

export const describeNextFrecuencyDate = (recurrence_rule) => {
	if(recurrence_rule.frequency === "" || recurrence_rule.interval === 0){
		return "";
	}
	
	const { start_date, end_date, frequency, interval } = recurrence_rule;
	const currentDate = dayjs();
	const startDate = dayjs(start_date);

	if(end_date !== "" && currentDate.isAfter(dayjs(end_date), "day")){
		return "Terminado";
	}

	let nextEmissionDate = startDate;

	while (nextEmissionDate.isBefore(currentDate, "day") || nextEmissionDate.isSame(currentDate, "day")) {
		switch (frequency) {
		case "daily":
			nextEmissionDate = nextEmissionDate.add(interval, "day");
			break;
		case "weekly":
			nextEmissionDate = nextEmissionDate.add(interval, "week");
			break;
		case "monthly":
			nextEmissionDate = nextEmissionDate.add(interval, "month");
			break;
		case "yearly":
			nextEmissionDate = nextEmissionDate.add(interval, "year");
			break;
		}
	}

	if (end_date !== "" && nextEmissionDate.isAfter(dayjs(end_date), "day")) {
		return "Terminado";
	}

	return nextEmissionDate.format("YYYY-MM-DD");
};